import { withStyles } from '@material-ui/core/styles';
import MaterialTooltip from '@material-ui/core/Tooltip';

// Custom styles for the tooltip
const StyledTooltip = withStyles(() => ({
  tooltip: {
    padding: '0.5rem 0.75rem', // px-3 py-2
    fontSize: '0.75rem', // text-xs
    fontWeight: 500, // font-medium
    color: '#ffffff', // text-white
    backgroundColor: '#1a1a1a', // bg-gray-900
    borderRadius: '0.5rem', // rounded-lg
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)', // shadow-md
    whiteSpace: 'nowrap', // whitespace-nowrap
  },
}))(MaterialTooltip);

// Custom Tooltip component that accepts a "text" prop instead of "title"
const Tooltip = ({ text, children, position = "bottom", ...props }) => {
  return (
    <StyledTooltip 
    title={text} 
    position = {position} 
    {...props}>
      {children}
    </StyledTooltip>
  );
};

export default Tooltip;
